import React from 'react';
import styled from 'styled-components';
import { SearchInput, SearchInputProps } from 'component-library-and-tools';

import { colors } from 'lib/prisma-styles';

const SEARCH_INPUT_TEXT_CLASS_NAME = 'search-bar__input-text';
const SEARCH_ICON_CLASS_NAME = 'search-bar__icon';

const StyledSearchInput = styled(SearchInput)`
  // Some rules are the same rules as in the TextField component. The problem is that SearchBar uses the SearchInput
  // component, which in turns uses a TextInput under the hood. There are ways to fix this (like allowing SearchInput
  // to use a custom component), but it's not worth the effort.
  && {
    background-color: ${colors.interactive.defaultBackground};
    border-color: ${colors.interactive.defaultBorder};

    &:focus-within {
      border-color: ${colors.interactive.defaultBorder};
    }

    .${SEARCH_INPUT_TEXT_CLASS_NAME} {
      &::placeholder {
        color: #8d9199;
      }
    }

    .${SEARCH_ICON_CLASS_NAME} {
      font-size: 1.333333333rem;
      font-weight: 700;
      color: #8d9199;
    }
  }
`;

const SearchBar = (props: SearchInputProps) => (
  <StyledSearchInput
    {...props}
    inputClassName={SEARCH_INPUT_TEXT_CLASS_NAME}
    iconClassName={SEARCH_ICON_CLASS_NAME}
  />
);

export default SearchBar;
